import { Component, Input, TemplateRef } from "@angular/core";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { ɵNzTabCloseButtonComponent } from "ng-zorro-antd/tabs";

@Component({
  selector: "ui-tab-close-button, button[ui-tab-close-button]",
  templateUrl: "./tab-close-button.component.html",
})
export class UiTabCloseButtonComponent extends ɵNzTabCloseButtonComponent {
  @Input() public closeIcon: string | TemplateRef<NzSafeAny> = "close";
}
